import { addErrorToast } from '@clay-run/glaze/toast/index';

import { WriteRefusedError } from './fetch-error';

/**
 * `addErrorToast` for a failed API call. Core `apiFetch` already toasted a
 * refused write (read-only impersonation, external-write sandbox) before it
 * rejected with `WriteRefusedError`, so toasting it again would show the rep
 * two errors for one action. Every other error toasts as usual.
 */
export function addApiErrorToast(config: Parameters<typeof addErrorToast>[0]): void {
  if (config.error instanceof WriteRefusedError) return;
  addErrorToast(config);
}
